import React from 'react';

type SpinnerSize = 'sm' | 'md' | 'lg' | 'xl';
type SpinnerColor =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark';

interface SpinnerProps {
  size?: SpinnerSize;
  color?: SpinnerColor;
  className?: string;
  fullScreen?: boolean;
  label?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = 'md',
  color = 'primary',
  className = '',
  fullScreen = false,
  label = 'Loading...',
}) => {
  // Determine size class
  let sizeClass = '';
  switch (size) {
    case 'sm':
      sizeClass = 'spinner-border-sm';
      break;
    case 'lg':
      sizeClass = 'h-3 w-3';
      break;
    case 'xl':
      sizeClass = 'h-6 w-6';
      break;
    default:
      sizeClass = '';
  }

  const spinnerElement = (
    <div className={`spinner-border text-${color} ${sizeClass} ${className}`} role="status">
      <span className="sr-only">{label}</span>
    </div>
  );

  if (fullScreen) {
    return (
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000,
        }}
      >
        <div style={{ textAlign: 'center' }}>
          {spinnerElement}
          <p style={{ marginTop: '1rem' }}>{label}</p>
        </div>
      </div>
    );
  }

  return spinnerElement;
};

export default Spinner;
